<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <div class="big-img-div" v-show="isShowImg" @click="onHideImgDiv">
        <img ref="bigImg" src="" alt="">
      </div>
      <table-box ref="tableBox" :tableTitle="'部件模板管理'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">部件名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$validateAuthority(2800000,2801000,2801001)" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAddParts">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">添加模板</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.name === 'img' && Object.prototype.hasOwnProperty.call(props.item, 'img')" :key="index">
                <div class="img-div">
                  <img :src="`${$imgBaseURL}/${props.item.img}`" alt="" @click="onShowImg(props.item)">
                </div>
              </td>
              <td v-else-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span class="cursor-el" @click="onShowEditParts(props.item)">编辑</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import MachineryPartsAddLayer from "../layer/MachineryPartsAddLayer"
import MachineryPartsEditLayer from "../layer/MachineryPartsEditLayer"
import { getMachineryPartsItems } from "../../common/api";

export default {
  name: "PartsBases",
  components: { TableBox },
  data() {
    return {
      isShowImg: false,
      action: getMachineryPartsItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "部件名称", name: "name", title: "name", isHtml: false, value: this.getObjValue },
        { state: true, alias: "图片", name: "img", title: "img", isHtml: false, value: this.getObjValue },
        { state: true, alias: "类型", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "副标题", name: "subtitle", title: "subtitle", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新时间", name: "updateTime", title: "updateTime", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新人", name: "updater", title: "updater", isHtml: false, value: this.getObjValue }
      ]
    }
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(2800000,2801000,[2801002]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if (field === "type") {
        return item[field] === 1 ? "普通" : (item[field] === 2 ? "列表" : "标签");
      } else {
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowImg(item) {
      this.$refs.bigImg.src = `${this.$imgBaseURL}/${item.img}`;
      this.isShowImg = true;
    },
    onHideImgDiv() {
      this.isShowImg = false;
    },
    onShowAddParts() {
      this.$layer.iframe({
        content: {
          content: MachineryPartsAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "550px"],
        title: "添加设备部件模板"
      });
    },
    onShowEditParts(item) {
      this.$layer.iframe({
        content: {
          content: MachineryPartsEditLayer,
          parent: this,
          data: {
            partsBase: item,
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "550px"],
        title: "修改设备部件模板"
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .big-img-div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        align-items: center;
      }
    }
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 60px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 90px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .img-div {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        align-items: center;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>